import { render, staticRenderFns } from "./SelectPlace.vue?vue&type=template&id=552b715f"
import script from "./SelectPlace.vue?vue&type=script&lang=js"
export * from "./SelectPlace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports